import { call, put, takeLatest } from "redux-saga/effects";
import { hinhThucTinhApi } from "../../../api/mien-giam/hinhThucTinhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eHinhThucTinhActionIds } from "../../action-types/mien-giam/IHinhThucTinhActions";
import { rootActions } from "../../actions/rootActions";

export function* hinhThucTinhSaga(): any {
  yield takeLatest(eHinhThucTinhActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(hinhThucTinhApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.mienGiam.hinhThucTinh.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mienGiam.hinhThucTinh.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
